export const DailyListKeys = {
  todayListName: "today",
  yesterdayListName: "yesterday",
  dayBeforeListName: "day-before",
};
